import ScrollView from 'devextreme-react/scroll-view';
import type { ReactNode } from 'react';
import { hasSecurePharmReportsAccess } from './roles';
import { useAuthStore } from './useAuthStore';

interface RequireSecurePharmReportsAccessProps {
  children: ReactNode;
}

/** Gates Secure Pharm Reports: ItSysAdmin, OpsPharmacy, OpsFinance, or OpsSales. */
export function RequireSecurePharmReportsAccess({ children }: RequireSecurePharmReportsAccessProps) {
  const roles = useAuthStore((s) => s.roles);

  if (!hasSecurePharmReportsAccess(roles)) {
    return (
      <ScrollView>
        <div style={{ padding: '2rem', maxWidth: 560 }}>
          <h2>Access denied</h2>
          <p>
            You don&apos;t have permission to view this page. Required: ItSysAdmin, OpsPharmacy, OpsFinance, or OpsSales.
          </p>
        </div>
      </ScrollView>
    );
  }

  return <>{children}</>;
}
